export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export default function generateQueryParams(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }
    // If value is an array, append each item
    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item !== undefined && item !== null && item !== '') {
          searchParams.append(`${key}[]`, String(item))
        }
      })
    } else {
      searchParams.append(key, String(value))
    }
  })
  return searchParams.toString()
}
